<div class="page">
  <div class="header">
    <div>
      <h2 class="title">Forecast + Optimizer Endpoints</h2>
      <p class="subtitle">
        Pick a location to fill <code>location_id</code>, then use the request JSON on each endpoint to call the current forecast-input and optimizer APIs.
      </p>
    </div>

    <div class="header-actions">
      <button mat-stroked-button type="button" (click)="clearAll()">Clear responses</button>
    </div>
  </div>

  <div class="location-row">
    <mat-form-field appearance="outline" class="location-select">
      <mat-label>Location</mat-label>
      <mat-select [value]="selectedLocationId()" (valueChange)="setLocationId($event)">
        @for (loc of locationState.locations(); track loc.id) {
          <mat-option [value]="loc.id">{{ loc.name }} ({{ loc.id }})</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="location-meta">
      <div><strong>Name:</strong> {{ selectedLocationName() || '-' }}</div>
      <div><strong>ID:</strong> <code>{{ selectedLocationId() || '-' }}</code></div>
    </div>
  </div>

  <div class="single-input">
    <section class="card">
      <h3>Optimizer results input</h3>
      <textarea
        [ngModel]="optimizerResultJson()"
        (ngModelChange)="optimizerResultJson.set($event)"
        rows="8"
        spellcheck="false"
      ></textarea>
      <div class="hint">
        Used by <code>POST {{ '/locations/{location_id}/optimizer/results' }}</code>.
        Shape: <code>ForecastOptimizationResult</code>
      </div>
    </section>
  </div>

  @for (group of endpointDocs; track group.group) {
    <section class="group">
      <h3 class="group-title">{{ group.group }}</h3>

      <div class="endpoint-list">
        @for (ep of group.items; track ep.key) {
          <div class="endpoint" [class.endpoint-disabled]="isEndpointDisabled(ep.key)">
            <div class="endpoint-head">
              <div class="endpoint-title">{{ ep.name }}</div>
              <div class="endpoint-url">
                <span class="pill">{{ ep.method }}</span>
                <code>{{ ep.path }}</code>
              </div>
            </div>

            <div class="endpoint-body">
              <div class="endpoint-params">
                <div class="params-title">Input parameters</div>
                <ul>
                  @for (row of ep.input; track row) {
                    <li>{{ row }}</li>
                  }
                </ul>
              </div>

              @if (isDateRangeEndpoint(ep.key)) {
                <div class="endpoint-request">
                  <label class="request-label">Date range request JSON</label>
                  <textarea
                    [ngModel]="dateRangeJsons()[ep.key]"
                    (ngModelChange)="updateDateRangeJson(ep.key, $event)"
                    rows="6"
                    spellcheck="false"
                  ></textarea>
                  <div class="hint">
                    Sent as <code>from</code>/<code>to</code> query parameters.
                    Shape: <code>&#123; "startDate": "...", "endDate": "..." &#125;</code>
                  </div>
                </div>
              }

              <div class="endpoint-actions">
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  (click)="call(ep.key)"
                  [disabled]="loading()[ep.key] || isEndpointDisabled(ep.key)"
                  [class.disabled-action-btn]="isEndpointDisabled(ep.key)"
                >
                  Call endpoint
                </button>
                @if (isEndpointDisabled(ep.key)) {
                  <div class="status status-disabled">Disabled</div>
                }
                @if (loading()[ep.key]) {
                  <div class="status">Loading…</div>
                }
              </div>

              @if (errors()[ep.key]) {
                <div class="error">
                  <strong>Error:</strong>
                  <pre>{{ errors()[ep.key] }}</pre>
                </div>
              }

              @if (responses()[ep.key]) {
                <div class="response">
                  <strong>Response:</strong>
                  <pre>{{ responses()[ep.key] | json }}</pre>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </section>
  }
</div>
